
var Constants = {
    DISPATCHER: "SLIDE_OUT_TAB_DISPATCHER",
    OPEN: "OPEN_TAB",
    CLOSE: "CLOSE_TAB",
    FLASH: "FLASH_TAB"
};

export default Constants;